import styled from 'styled-components';

const Wrapper = styled.div`
  margin: 100px auto;
  width: 98%;
  margin-bottom: 100px;
`;

export default Wrapper;
